var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KButton',{attrs:{"text":"Show snackbar with action"},on:{"click":_vm.showWithAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }